import gCard from "@/components/g-card/g-card.vue"
import gButton from "@/components/g-button/g-button.vue"
import gForm from "@/components/g-form/g-form.vue";
import ClienteController from "@/shared/controllers/cliente/clienteController";
 
const name = 'OrcamentoFinal'
export default {
  name,

  components: {
    'g-card':gCard,
    'g-button': gButton,
    'g-form': gForm
  }, 

  props: { },

  mounted () { 
    var ClienteId = this.$route.params.id
    this.ClienteSelecionado = ClienteId

    var unidadeId = this.$route.params.unidadeId
    this.UnidadeId = unidadeId

    this.informacoesdocliente()
    this.informacoesdoclienteCredito()
    this.mitt.on('trocaEmpresaRepresentante', () => {
       this.atualizaEmpresaRepresentante()
     })
    

  },

  updated () { },

  data () {
    return {
      options: [],
      ClienteSelecionado: null,
      InformacoesClienteSelecionado: {},
      InfomacaoClienteArray:[],
      InfomacaoClienteUnidadeArray:[],
      InformacaoClienteTelefoneArray:[],
      InformacaoClienteCelularArray:[],
      InformacaoClienteEmailArray:[],
      existeClientAgrupador: false,
      InformacoesClienteCreditoSelecionado: {},
      TemInformacoesCredito: false,
      TemInformacoesContato: true,
      TemInformacoesEndereco: true
    }
  },

  methods: {

    atualizaEmpresaRepresentante(){
      this.RepresentanteId = this.$store.state.representanteSelecionadoId;
      this.informacoesdocliente()
    },

    informacoesdocliente(){
      this.$isLoading(true)
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'Cliente/VerificaClienteByEmpresaRepresentante',
        data:
        {
          Id: this.ClienteSelecionado,
          UnidadeId: this.UnidadeId,
          RepresentanteId: this.RepresentanteId
        }
      })
        .then((response) => {

          this.InformacoesClienteSelecionado = response.data.data

          if(response.data.data.contatos.length == 0)
          {
            this.TemInformacoesContato = false
          }

          if(response.data.data.enderecos.length == 0)
          {
            this.TemInformacoesEndereco = false
          }

          this.$isLoading(false)
        })
        .catch(() => {
        });
    },

    informacoesdoclienteCredito(){
      ClienteController.GetClienteCreditoByClienteIdEmpresaId(this.ClienteSelecionado, this.UnidadeId)
      .requisicao.then((Response) => {
        if(Response.data.data != null)
        {
          this.InformacoesClienteCreditoSelecionado = Response.data.data;
          this.TemInformacoesCredito = true
        }
        else{
          this.TemInformacoesCredito = false
        }

      })
      .catch(() => {
      });
      
      
    },

   
    voltar (){
      this.$router.push(`/cliente-consulta`)
    },
    
  },

  computed: { 

  }, 

};